import { render, staticRenderFns } from "./DailyNotesModal.vue?vue&type=template&id=0c0db482&"
import script from "./DailyNotesModal.vue?vue&type=script&lang=js&"
export * from "./DailyNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports